export const WITHDRAW_LIMIT = 250000;
export const DEPOSIT_LIMIT = 250000;
export const TRANSFER_LIMIT = 250000;

export const FEE_LIMIT = 20000;

export enum BankErrors {
  NOT_ENOUGH_MONEY_ERROR = "NOT_ENOUGH_MONEY_ERROR",
}
